import { SessionExtra } from "../../store/Session/SessionModel";

interface Props {
	sessionData: SessionExtra;
}
const CombineScore = ({ sessionData }: Props) => {
	const sessionQuality = sessionData?.sessionQuality?.toFixed() ?? "---";
	return (
		<div className="combine-item">
			<div className="combine-item-header">Combine Score</div>
			<div className="combine-item-score combine">{sessionQuality}</div>
			<div className="combine-item-footer">
				<span className="all-target">All Targets</span>
			</div>
		</div>
	);
};
export default CombineScore;
